<i18n>
{
	"en": {
		"title": "Log",
		"trip": "Trip",
		"order": "Order",
		"map": "Map"
	},
	"no": {
		"title": "Logg",
		"trip": "Tur",
		"order": "Oppdrag",
		"map": "Kart"
	}
}
</i18n>
<template>
	<t-dialog
		:isShown="isShown"
		icon="history"
		iconType="bp"
		:title="$t('title')"
		width="600px"
		@close="onClose"
		@shown="ready = true"
	>
		<t-tab-view
			:tabs="tabs"
			:orderEvents="order.events"
			:ready="ready"
		/>
	</t-dialog>
</template>

<script>
import OrderLog from './Log/OrderLog';
import LogMap from './Log/LogMap';

export default {
	name: 'Log',
	props: {
		isShown: Boolean,
		order: Object
	},
	data() {
		return { ready: false };
	},
	computed: {
		tabs() {
			return [
				{
					component: OrderLog,
					label: this.$t('order'),
				},{
					component: LogMap,
					label: this.$t('map')
				}
			];
		},
	},
	methods: {
		onClose() {
			this.ready = false;
			this.$emit('close');
		},
	}
};
</script>
